module.exports = __webpack_public_path__ + "static/media/help_business_profile_on_jobdetail.cfeb85a5.jpg";